import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { Grid } from "@mui/material";
import { styles } from "./styles";
import AppBarHeader from "../components/AppBar/Index";
import AppSideBar from "../components/AppSideBar";
import Breadcrumb from "../components/BreadCrumbs";
import DashboardCard from "../components/DashboardCard";
import AppContent from "../components/AppContent";
import { getAllCounts } from "../api/fetch";

const mdTheme = createTheme();

function DashboardContent() {
  // For Css Classes  ----------->>>>>>>>>>>
  const classes = styles();

  // Getter And Setter State's -------->>>>>>>>>>>>
  const [open, setOpen] = React.useState(true);
  const [count, setCount] = React.useState([]);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  React.useEffect(() => {
    const fetchCounts = async () => {
      const res = await getAllCounts();
      console.log("RESss ::", res);
      if (res?.status) {
        setCount(res?.data[0]);
      }
    };
    fetchCounts();
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBarHeader
          open={open}
          handleOpenUserMenu={handleOpenUserMenu}
          handleCloseUserMenu={handleCloseUserMenu}
          anchorElUser={anchorElUser}
          toggleDrawer={toggleDrawer}
        />
        <AppSideBar open={open} toggleDrawer={toggleDrawer} classes={classes} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[300]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Breadcrumb />

          <Grid container>
            <Grid item xs={4}>
              <DashboardCard
                label={"Total Drivers"}
                c1={"#ff7e5f"}
                c2={"#feb47b"}
                nav={"Driver"}
                role="Driver"
                count={count?.total_drivers}
              />
              <DashboardCard
                label={"Wallet Transaction Report"}
                c1={"#4a90e2"}
                c2={"#d06eae"}
                nav={"AllWallet"}
                count={count?.total_wallet_amount}
                // role="Driver"
              />
            </Grid>
            <Grid item xs={4}>
              <DashboardCard
                label={"Total Bookings"}
                c1={"#f06292"}
                c2={"#00bcd4"}
                nav={"Allbooking"}
                count={count?.total_bookings}
              />
            </Grid>
            <Grid item xs={4}>
              <DashboardCard
                label={"Total Customers"}
                c1={"#4a90e2"}
                c2={"#d06eae"}
                nav={"Customer"}
                role={"Customer"}
                count={count?.total_customers}
              />
            </Grid>
          </Grid>

          <AppContent />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default function DefaultLayout() {
  return <DashboardContent />;
}
